import React from 'react';
import { Link } from 'react-router-dom';

export default function SummaryWidget({ rows }) {
  const safe = Array.isArray(rows) ? rows : [];

  const investment  = safe.reduce((s, r) => s + Number(r.average_price || 0) * Number(r.quantity || 0), 0);
  const current     = safe.reduce((s, r) => s + Number(r.last_price   || 0) * Number(r.quantity || 0), 0);
  const totalPnL    = current - investment;
  const pnlPct      = investment > 0 ? (totalPnL / investment) * 100 : 0;
  const dayPnL      = safe.reduce((s, r) => s + Number(r.day_change || 0) * Number(r.quantity || 0), 0);
  const dayPnLPct   = current > 0 ? (dayPnL / (current - dayPnL)) * 100 : 0;

  const best  = safe.length ? safe.reduce((a, b) =>
    Number(b.day_change_percentage || 0) > Number(a.day_change_percentage || 0) ? b : a, safe[0]) : null;
  const worst = safe.length ? safe.reduce((a, b) =>
    Number(b.day_change_percentage || 0) < Number(a.day_change_percentage || 0) ? b : a, safe[0]) : null;

  const pnlColor  = totalPnL >= 0 ? '#16a34a' : '#dc2626';
  const dayColor  = dayPnL  >= 0 ? '#16a34a' : '#dc2626';

  const fmt = (n, dec = 0) =>
    Math.abs(n).toLocaleString('en-IN', { minimumFractionDigits: dec, maximumFractionDigits: dec });

  const sign = n => n >= 0 ? '+' : '-';

  if (safe.length === 0) return null;

  return (
    <div style={{
      background: '#fff',
      borderRadius: 10,
      border: '1px solid #e2e8f0',
      padding: '1rem 1.25rem',
      marginBottom: '1rem',
      boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
    }}>
      {/* Top row: main P&L metrics */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '0.75rem 1.5rem' }}>

        <Stat
          label="Total P&L"
          value={`${sign(totalPnL)}₹${fmt(totalPnL, 0)}`}
          sub={`${sign(pnlPct)}${Math.abs(pnlPct).toFixed(2)}%`}
          color={pnlColor}
          bold
        />
        <Stat
          label="Today's P&L"
          value={`${sign(dayPnL)}₹${fmt(dayPnL, 0)}`}
          sub={`${sign(dayPnLPct)}${Math.abs(dayPnLPct).toFixed(2)}%`}
          color={dayColor}
        />
        <Stat
          label="Current Value"
          value={`₹${fmt(current, 0)}`}
          sub={`Invested ₹${fmt(investment, 0)}`}
          color="#0f172a"
        />
        <Stat
          label="Holdings"
          value={safe.length}
          sub={
            <Link to="/analysis" style={{ fontSize: '0.7rem', color: '#0ea5e9', textDecoration: 'none', fontWeight: 600 }}>
              View Analysis →
            </Link>
          }
          color="#0f172a"
        />

        {best && best.tradingsymbol && (
          <Stat
            label="Best Today"
            value={best.tradingsymbol}
            sub={`${Number(best.day_change_percentage || 0) >= 0 ? '+' : ''}${Number(best.day_change_percentage || 0).toFixed(2)}%`}
            color="#16a34a"
          />
        )}
        {worst && worst.tradingsymbol && worst.tradingsymbol !== best?.tradingsymbol && (
          <Stat
            label="Worst Today"
            value={worst.tradingsymbol}
            sub={`${Number(worst.day_change_percentage || 0) >= 0 ? '+' : ''}${Number(worst.day_change_percentage || 0).toFixed(2)}%`}
            color="#dc2626"
          />
        )}
      </div>
    </div>
  );
}

function Stat({ label, value, sub, color, bold }) {
  return (
    <div>
      <div style={{ fontSize: '0.7rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 2 }}>
        {label}
      </div>
      <div style={{ fontSize: bold ? '1.15rem' : '1rem', fontWeight: bold ? 800 : 700, color, lineHeight: 1.2 }}>
        {value}
      </div>
      {sub && (
        <div style={{ fontSize: '0.72rem', color: typeof sub === 'string' ? '#64748b' : undefined, marginTop: 1 }}>
          {sub}
        </div>
      )}
    </div>
  );
}
